import React from 'react'
import AddImageCamera from "../../../assets/icons/add-image-camera.svg"
export const AddImageCameraIcon = () => {
  return (
    <img src={AddImageCamera} alt="" className="w-[25px] h-[18px] absolute bottom-[11px] right-[13px]"/>
  )
}
